var configs = {
    clear: false,
    form: false,
    input: false,
    submit: false
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/searchfield/_configs.js
// module id = 80
// module chunks = 0